import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { surveysApi } from '@/api/surveys';
import DynamicSurveyForm from '@/components/form/DynamicSurveyForm';
import TestPageLayout from '@/components/tests/TestPageLayout';
import { Alert } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import Loading from '@/components/ui/Loading';
import useScrollProgress from '@/hooks/use-scroll-progress';
import SurveySectionNav from './components/SurveySectionNav';

export default function SurveyPreview() {
    const { id } = useParams();
    const navigate = useNavigate();
    const scrollProgress = useScrollProgress();

    const { data: surveys = [], isLoading } = useQuery({
        queryKey: ['surveys'],
        queryFn: surveysApi.list,
    });

    const survey = surveys.find((s) => s.id === id);

    if (isLoading) return <Loading />;

    if (!survey) {
        return (
            <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
                <div className="text-center">
                    <h1 className="mb-2 text-2xl font-bold text-foreground">
                        Formulário não encontrado
                    </h1>
                    <p className="mb-6 text-muted-foreground">
                        O formulário que você está tentando visualizar não existe.
                    </p>
                    <Button onClick={() => navigate('/surveys')}>Voltar para Formulários</Button>
                </div>
            </div>
        );
    }

    return (
        <TestPageLayout
            progress={scrollProgress}
            onBack={() => navigate('/surveys')}
            mainClassName="max-w-6xl"
        >
            <div className="flex items-start gap-6">
                <SurveySectionNav sections={survey.sections} />
                <div className="flex-1">
                    <div className="mb-8 rounded-xl bg-card p-6 shadow-elevation-1 md:p-8">
                        <h1 className="mb-6 border-b pb-4 text-2xl font-bold text-foreground">
                            {survey.name}
                        </h1>
                        {survey.instructions ? (
                            <p className="mb-6 rounded-lg bg-brand-subtle p-4 text-sm leading-relaxed text-foreground">
                                {survey.instructions}
                            </p>
                        ) : null}

                        <Alert variant="info">
                            <strong>Modo de Visualização:</strong> Este é um exemplo de como o
                            paciente verá o formulário. Os campos estão desabilitados e o botão de
                            envio não funciona.
                        </Alert>
                    </div>

                    <DynamicSurveyForm
                        survey={survey}
                        onSubmit={() => {}}
                        disabled={true}
                        variant="flat"
                    >
                        <div className="mt-8 flex justify-end">
                            <Button
                                type="submit"
                                size="lg"
                                className="w-full cursor-not-allowed opacity-50 md:w-auto"
                                disabled={true}
                            >
                                Enviar Respostas
                            </Button>
                        </div>
                    </DynamicSurveyForm>
                </div>
            </div>
        </TestPageLayout>
    );
}
